export default __webpack_public_path__ + "static/media/ico-beli.74a2c0b3.webp";